module.exports = __webpack_public_path__ + "img/step2.2d1016c4.svg";